// EjecutivoInfo.jsx
export const EjecutivoInfo = ({ name_admin, puesto, email_admin, phone_admin }) => {
    return (
        <div className="border rounded p-4 shadow-sm bg-light">
            <h4 className="mb-3 text-dark font-weight-bold">Información del Ejecutivo</h4>
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Ejecutiva:</h5>
                <p className="mb-0">{name_admin}</p>
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Cargo:</h5>
                <p className="mb-0">{puesto}</p>
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Departamento:</h5>
                <p className="mb-0">Mercadeo y ventas</p>
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Correo Electrónico:</h5>
                <p className="mb-0">{email_admin}</p>
            </div>
            <hr />
            <div>
                <h5 className="mb-1 text-grey">Teléfono:</h5>
                <p className="mb-0">{phone_admin}</p>
            </div>
            <br />
            <br />
            <br />
        </div>
    );
};
